// Highlighting for code blocks
import './src/styles/globals.css';

require('prismjs/themes/prism-solarizedlight.css');

// require('./src/styles/globals.css');
